import { useState, useEffect } from 'react';
import { useAuthState } from 'react-firebase-hooks/auth';

import { ApiService } from '../services/api';
import { auth } from '../services/firebase';

const useApi = () => {
  const [user] = useAuthState(auth);
  const [service, setService] = useState<ApiService | null>(null);

  useEffect(() => {
    if (user && (user as any).accessToken) {
      setService(new ApiService((user as any).accessToken));
    }
  }, [user]);

  return service;
};

export default useApi;
